(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dt-countdown"] && !Shopify.designMode) return;
  try {
    
  class DtCountdownTimer extends HTMLElement {
    connectedCallback() {
      var iso = this.getAttribute('data-target');
      var target = iso ? new Date(iso) : null;

      this.tiles = this.querySelector('[data-countdown-tiles]');
      this.fallback = this.querySelector('[data-countdown-fallback]');
      this.expired = this.querySelector('[data-countdown-expired]');
      this.srSummary = this.querySelector('[data-countdown-sr]');
      this.units = {
        d: this.querySelector('[data-unit="d"]'),
        h: this.querySelector('[data-unit="h"]'),
        m: this.querySelector('[data-unit="m"]'),
        s: this.querySelector('[data-unit="s"]')
      };
      this.srInitialized = false;

      if (!target || isNaN(target.getTime())) {
        this.showExpired();
        return;
      }

      this.target = target;
      this.tick();
      this.interval = window.setInterval(this.tick.bind(this), 1000);
    }

    disconnectedCallback() {
      if (this.interval) window.clearInterval(this.interval);
    }

    tick() {
      var diff = this.target.getTime() - Date.now();

      if (diff <= 0) {
        this.showExpired();
        return;
      }

      var totalSeconds = Math.floor(diff / 1000);
      var days = Math.floor(totalSeconds / 86400);
      var hours = Math.floor((totalSeconds % 86400) / 3600);
      var minutes = Math.floor((totalSeconds % 3600) / 60);
      var seconds = totalSeconds % 60;

      function pad(value) {
        return String(value).padStart(2, '0');
      }

      if (this.units.d) this.units.d.textContent = pad(days);
      if (this.units.h) this.units.h.textContent = pad(hours);
      if (this.units.m) this.units.m.textContent = pad(minutes);
      if (this.units.s) this.units.s.textContent = pad(seconds);

      if (this.fallback && !this.fallback.hidden) this.fallback.hidden = true;
      if (this.tiles && this.tiles.hidden) this.tiles.hidden = false;

      if (this.srSummary && (seconds === 0 || !this.srInitialized)) {
        this.srInitialized = true;
        var dayLabel = days === 1 ? 'zi' : 'zile';
        this.srSummary.textContent =
          'mai sunt ' + days + ' ' + dayLabel + ', ' + hours + ' ore și ' + minutes + ' minute până la drop.';
      }
    }

    showExpired() {
      if (this.interval) window.clearInterval(this.interval);
      if (this.tiles) this.tiles.hidden = true;
      if (this.fallback) this.fallback.hidden = true;
      if (this.srSummary) this.srSummary.hidden = true;
      if (this.expired) this.expired.hidden = false;
    }
  }

  if (!window.customElements.get('dt-countdown-timer')) {
    window.customElements.define('dt-countdown-timer', DtCountdownTimer);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dt-giveaway"] && !Shopify.designMode) return;
  try {
    
class DtGiveawayCountdown extends HTMLElement {
  connectedCallback() {
    const iso = this.dataset.deadline;
    this.target = iso ? new Date(iso) : null;
    this.output = this.querySelector('[data-giveaway-remaining]');

    if (!this.target || isNaN(this.target.getTime()) || !this.output) return;

    this.render();
    this.interval = window.setInterval(this.render.bind(this), 60000);
  }

  disconnectedCallback() {
    if (this.interval) window.clearInterval(this.interval);
  }

  render() {
    const diff = this.target.getTime() - Date.now();

    if (diff <= 0) {
      this.output.textContent = this.dataset.expiredText || '00z 00h 00m';
      if (this.interval) window.clearInterval(this.interval);
      return;
    }

    const totalMinutes = Math.floor(diff / 60000);
    const days = Math.floor(totalMinutes / 1440);
    const hours = Math.floor((totalMinutes % 1440) / 60);
    const minutes = totalMinutes % 60;
    const pad = (n) => String(n).padStart(2, '0');

    this.output.textContent = pad(days) + 'z ' + pad(hours) + 'h ' + pad(minutes) + 'm';
  }
}

if (!customElements.get('dt-giveaway-countdown')) {
  customElements.define('dt-giveaway-countdown', DtGiveawayCountdown);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dt-offers"] && !Shopify.designMode) return;
  try {
    
class DtCopyCode extends HTMLElement {
  connectedCallback() {
    this.trigger = this.querySelector('[data-copy-trigger]');
    this.hint = this.querySelector('[data-copy-hint]');
    this.status = this.querySelector('[data-copy-status]');
    if (!this.trigger) return;

    this.defaultHint = this.hint ? this.hint.textContent : '';
    this.trigger.addEventListener('click', this.copy.bind(this));
  }

  async copy() {
    const code = this.dataset.code || '';
    if (!code) return;

    let ok = false;
    try {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(code);
        ok = true;
      } else {
        const ta = document.createElement('textarea');
        ta.value = code;
        ta.setAttribute('readonly', '');
        ta.style.position = 'absolute';
        ta.style.left = '-9999px';
        document.body.appendChild(ta);
        ta.select();
        ok = document.execCommand('copy');
        document.body.removeChild(ta);
      }
    } catch (e) {
      ok = false;
    }

    const message = ok
      ? this.getAttribute('data-copied-text') || 'copiat'
      : this.getAttribute('data-failed-text') || code;

    if (this.hint) {
      this.hint.textContent = message;
      window.clearTimeout(this.resetTimer);
      this.resetTimer = window.setTimeout(() => {
        this.hint.textContent = this.defaultHint;
      }, 2000);
    }

    if (this.status) this.status.textContent = message;
  }
}

if (!customElements.get('dt-copy-code')) {
  customElements.define('dt-copy-code', DtCopyCode);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
